import { useEffect, useState } from "react";
import "./App.css";
import ChargeCardForm from "./Pages/ChargeCardForm";
import MobileNumberPage from "./Pages/MobileNumberPage";
import Otp from "./Pages/OtpPage";
import hypermeImg from "./Assets/Images/hyperme.png";
import Alert from "./Components/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import ResPage from "./Pages/ResPage";

function App() {
  const [response, setResponse] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [pageState, setPageState] = useState("mobileNum");
  const [isLoading, setIsLoading] = useState(false);
  const [finalRes, setFinalRes] = useState({});
  const onResRecieve = (newResponse) => {
    if (!newResponse) return;
    if (newResponse.title && newResponse.title === "disabled")
      newOperationHandler();
    setResponse(newResponse);
    if (newResponse.sessionId) setSessionId(newResponse.sessionId);
    if (newResponse.otpId) setSessionId(newResponse.otpId);
    setIsLoading(false);
  };
  useEffect(() => {
    if (!finalRes) return;
    setResponse(null);
    setIsLoading(false);
  }, [finalRes]);

  const newOperationHandler = () => {
    window.location.reload();
  };

  const renderUI = () => {
    switch (pageState) {
      case "mobileNum":
        return (
          <MobileNumberPage
            setPageState={setPageState}
            onResRecieve={onResRecieve}
            mobileNumber={mobileNumber}
            onMobileNumberChange={setMobileNumber}
            setIsLoading={setIsLoading}
          />
        );
      case "OTP":
        return (
          <Otp
            setPageState={setPageState}
            onResRecieve={onResRecieve}
            mobileNumber={mobileNumber}
            sessionId={sessionId}
            setIsLoading={setIsLoading}
          />
        );
      case "chargeCardForm":
        return (
          <ChargeCardForm
            onResRecieve={onResRecieve}
            setPageState={setPageState}
            mobileNumber={mobileNumber}
            otpId={sessionId}
            setIsLoading={setIsLoading}
            setFinalRes={setFinalRes}
            resetOperation={newOperationHandler}
          />
        );
      case "resPage":
        return (
          <ResPage res={finalRes} onNewOperationClick={newOperationHandler} />
        );
      default:
        return "404";
    }
  };

  return (
    <div className="Page centered-content">
      <div className="bgImage"></div>
      {isLoading ? (
        <div className="loading-and-modal-bg">
          <CircularProgress className="loading" />
        </div>
      ) : null}
      {response && (response.errorCode || response.msg) ? (
        <Alert
          msg={response.value || response.msg}
          onClose={() => setResponse(null)}
          type={response.errorCode ? "error" : "success"}
        />
      ) : null}
      <div className="charge-card-form">
        <div className="hyperme-img-box">
          <img
            className="charge-card-form__header--img"
            src={hypermeImg}
            alt="هایپرمی"
          />
        </div>
        <div className="charge-card-form__header">
          <div>سامانه انتقال شارژ</div>
          <div className="banner">باشگاه مشتریان کیمیا</div>
        </div>
        {renderUI()}
      </div>
    </div>
  );
}

export default App;
